const ACTIVITY_LOG_PATH_PREFIX = "/gwc";

/**
 * Activity logs are written with `path: /gwc<setPath>/<activitySlug>`
 */
export const buildActivityLogPath = (setPath, activitySlug) =>
  `${ACTIVITY_LOG_PATH_PREFIX}${setPath}/${activitySlug}`;

/**
 * Finds the curriculum activity a log belongs to.
 * Older logs may pair an activity's slug with the next activity's path, so fall back to slug:
 * within the logged set, or anywhere only when the slug is unique.
 *
 * @param {object}        log        Activity log item
 * @param {Array<object>} activities `{ activity, parentNode }` pairs from the curriculum tree
 * @returns {object|undefined} The matching pair
 */
export const findActivityNode = (log, activities) => {
  const bySlug = activities.filter((e) => e.activity.slug === log.title);
  const byPath = bySlug.find(
    (e) => !log.path || `${ACTIVITY_LOG_PATH_PREFIX}${e.activity.path}` === log.path
  );

  if (byPath) {
    return byPath;
  }

  if (log.activitySetSlug) {
    return bySlug.find((e) => e.parentNode?.slug === log.activitySetSlug);
  }

  return bySlug.length === 1 ? bySlug[0] : undefined;
};

/** Whether `log` was recorded for the same activity as `target`. */
export const isSameActivityLog = (log, target) =>
  log.title === target.title &&
  (log.path === target.path ||
    (!!target.activitySetSlug && log.activitySetSlug === target.activitySetSlug));
